import { render, staticRenderFns } from "./merchantManage.vue?vue&type=template&id=13d6c50c&scoped=true"
import script from "./merchantManage.vue?vue&type=script&lang=js"
export * from "./merchantManage.vue?vue&type=script&lang=js"
import style0 from "./merchantManage.vue?vue&type=style&index=0&id=13d6c50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6c50c",
  null
  
)

export default component.exports